import clsx from 'clsx'

import { TooltipInfo } from '../TooltipInfo'
import s from './Question.module.scss'
import type { QuestionProps } from './Question.props'

export function Question({ question, info, index, className }: QuestionProps) {
  const questionText = question.replace(/^<p>(.*?)<\/p>\s*$/s, '$1')

  return (
    <div className={clsx(s.question, className)}>
      {!!index && (
        <div className={s.questionNumber}>{index}</div>
      )}
      <div className={s.questionWrapper}>
        <span
          className={s.questionText}
          dangerouslySetInnerHTML={{ __html: questionText }}
        />
        {!!info && (
          <div className={s.questionInfo}>
            <TooltipInfo text={<div dangerouslySetInnerHTML={{ __html: info }} />} />
          </div>
        )}
      </div>
    </div>
  )
}
